module.exports = __webpack_public_path__ + "img/carticon.17c4a646.png";